import * as React from 'react'

import { Button, Link } from '@factorialco/deprecated-design-system'

import Separator from 'modules/core/components/Separator'

import Title from 'modules/posts/components/Title'

import './index.styles.css'
interface ImageProps {
  illustration: string
  title?: string
  width?: number
  height?: number
}
interface DescriptionProps {
  description: string
}
interface CtaProps {
  ctaLabel?: string
  onClick?: () => void
}
interface LinkProps {
  linkTo?: string
  linkHref?: string
  linkText?: string
}
type Props = ImageProps & DescriptionProps & CtaProps & LinkProps

function Image({ illustration, title, width = 200, height = 140 }: ImageProps) {
  return (
    <div className={'IllustratedBlankSlate_image'}>
      <img src={illustration} width={width} height={height} alt={title} title={title} />
    </div>
  )
}

function Description({ description }: DescriptionProps) {
  return <div className={'IllustratedBlankSlate_description'}>{description}</div>
}

function Cta({ onClick, ctaLabel = '' }: CtaProps) {
  if (!ctaLabel || !onClick) return null

  return (
    <div className={'IllustratedBlankSlate_cta'}>
      <Button onClick={onClick}>{ctaLabel}</Button>
    </div>
  )
}

export default function IllustratedBlankSlate({
  illustration,
  title,
  description,
  ctaLabel,
  linkTo,
  linkHref,
  linkText,
  onClick,
  width,
  height,
}: Props) {
  // FIXME: This could be easier to read
  return (
    <div className={'IllustratedBlankSlate_container'}>
      <Image illustration={illustration} title={title} width={width} height={height} />
      {title && <Title label={title} compact />}
      <Description description={description} />
      {!ctaLabel && !linkText && <Separator compact />}
      <Cta ctaLabel={ctaLabel} onClick={onClick} />
      {linkTo && linkText && (
        <div className={'IllustratedBlankSlate_link'}>
          <Link.Router to={linkTo}>{linkText || ''}</Link.Router>
        </div>
      )}
      {linkHref && linkText && (
        <div className={'IllustratedBlankSlate_link'}>
          <Link.Href href={linkHref} rel="nofollow noopener noreferrer" target="_blank">
            {linkText || ''}
          </Link.Href>
        </div>
      )}
    </div>
  )
}
